import React, { useEffect, useState } from "react";
import ChildPreview from "./ChildPreview";
import ImagePreview from "./ImagePreview";
import { getDisplayQuestions } from "src/services/Questionnaire/GetDisplayQuestions";
import SelectType from "./SelectType";

const PreviewComponent = ({ questions, data, heading }) => {
  const [displayQuestions, setDisplayQuestions] = useState([]);

  useEffect(() => {
    setDisplayQuestions(getDisplayQuestions(questions, data));
  }, [data]);

  var filteredQuestions = [];
  if (questions != undefined) {
    filteredQuestions = questions.filter((item) =>
      displayQuestions.includes(item.id)
    );
  }

  return (
    <div className="card" style={{ height: "100%" }}>
      <div
        className="card-header text-white"
        style={{ backgroundColor: "#3C4B64" }}
      >
        <div className="d-flex align-items-center justify-content-between">
          <span className="mr-auto">{heading}</span>
        </div>
      </div>
      <div className="table-responsive">
        <table className="table table-striped table-bordered table-hover">
          <tbody>
            {filteredQuestions && data ? (
              filteredQuestions.map((question, index) => (
                <>
                {
                  !question.hidden && (
                    <tr key={index}>
                  {question.type != "C" &&
                    question.type != "MC" &&
                    question.type != "F" && (
                      <>
                        {question.html ? (
                          <>
                            <td
                              scope="row"
                              style={{
                                width: "50%",
                                textAlign: "right",
                                fontSize: "80%",
                              }}
                            >
                              <b>{question.label}</b>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: question.label2,
                                }}
                                style={{ textAlign: "right" }}
                              />
                            </td>
                          </>
                        ) : (
                          <>
                            <td
                              scope="row"
                              style={{
                                width: "50%",
                                textAlign: "right",
                                fontSize: "80%",
                              }}
                            >
                              <b>{question.label}</b>
                              <br />
                              <span>{question.label2}</span>
                            </td>
                          </>
                        )}
                      </>
                    )}
                  {(question.type == "C" || question.type == "MC") && (
                    <td colSpan={2}>
                      <ChildPreview
                        questions={question.childVO}
                        data={data[question.id]}
                        parentQuestion={question}
                      ></ChildPreview>
                    </td>
                  )}
                  {question.type == "F" && (
                    <td colSpan={2}>
                      <h5>{question.label}</h5>
                      <ImagePreview
                        previewLabel={question.previewLabel}
                        parentQuestion={question}
                        data={data[question.id]}
                        isChild={false}
                      ></ImagePreview>
                    </td>
                  )}
                  {question.type == "B" && (
                    <input
                      type="checkbox"
                      name={question.id}
                      checked={
                        data[question.id] === "0" ? false : data[question.id]
                      }
                      className={`form-check m-3 w-90 custom-checkbox`}
                      style={{
                        backgroundColor: "initial",
                        border: "initial",
                        boxShadow: "none",
                      }}
                      disabled={true}
                    />
                  )}
                  {(question.type == "T" ||
                    question.type == "N" ||
                    question.type == "D" || question?.type == "TA") &&
                    data && <td>{data[question.id]}</td>}
                  {(question.type == "S" ||
                    question.type == "ST" ||
                    question.type == "M") && (
                    <td>
                      <SelectType
                        question={question}
                        data={data[question.id] || ""}
                        multiple={false}
                        disable={true}
                      ></SelectType>
                    </td>
                  )}
                </tr>
                  )
                }
                </>
              ))
            ) : (
              <></>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PreviewComponent;
